<template>
  <div>
    <Row class="exams">
      <Row class="exams-row">
          <Col span="6" class="exams-rowcol">
            <div class="exams-rowdiv"><img src="" alt=""><div><p>姓名：{{looksInfo.student?looksInfo.student.real_name:null}}</p><p>用户名：{{looksInfo.student?looksInfo.student.name:null}}</p></div></div>
            <Dropdown trigger="click" class="exams-rowcol-drop">
              <a href="javascript:void(0)">
                  答题卡<Icon type="ios-arrow-down"></Icon>
              </a>
              <DropdownMenu slot="list">
                <DropdownItem v-show="examsList&&examsList.length>0" v-for="(meun, indexm) in examsList" :key="indexm">
                  <p class="exams-rowcol-drop-tit">{{meun.name}}</p>
                  <div class="exams-rowcol-drop-div" v-show="meun.child&&meun.child.length>0" v-for="(item, index) in meun.child" :key="index">
                    <p>{{item.name}}</p>
                    <a @click="gotoCar(indexm,index)" v-for="(ite, i) in item.parts" :style="{'borderColor':ite.answe?'#549ce9':'#aaa','color':ite.answe?'#549ce9':'#aaa'}" :key="i">{{ite.start+i}}</a>
                  </div>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Col>
          <Col span="13">
          <div class="exams-rowp"><p>{{oneName}}</p>
          <img class="icon" src="@/assets/images/geli.png" alt=""
          ><p>{{twoName}}</p></div></Col>
          <Col span="4" class="exams-right">
            <p>{{hours}}:{{minutes}}:{{seconds}}</p>
            <Button @click="goSubmit">交卷</Button>
          </Col>
      </Row>
        <div v-show="examsList&&examsList.length>0" v-for="(items, indexs) in examsList" :key="indexs" style="width:100%">
          <div v-show="items.child&&items.child.length>0" v-for="(item, index) in items.child" :key="index" style="width:100%">
            <Row class="exams-list" v-if="num[0] === indexs&&num[1] === index">
            <div v-for="(ite, i) in item.parts" :key="i" style="width:100%">
              <p class="exams-p">
                <audioplay v-if="is_3(ite, 2)||is_4(ite)||is_4(ite, 1)" :myAudioUrl="ite.tigan_media"></audioplay>
              </p>
            <div class="questions">
              <div class="questions_title">
                <!-- {{ ite.name }} (本题{{ ite.each_score[0] * 1 }}分) -->
                  {{ ite.name }}(本题{{ ite.total_score?ite.total_score[0] * 1:'未知' }}分)
              </div>
                            <div class="question_content">
                <!-- ***************题型1 选择题 ******************-->
                <div v-if="is_1(ite)">
                  <h5>
                    <span class="index">{{ ite.start }}</span>
                    <div
                      class="text"
                      v-if="have_sub_heading(ite)"
                      v-html="set_sub_heading(ite)"
                    ></div>
                    <div
                      class="text"
                      v-else-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"
                    ></div>
                  </h5>
                  <!-- 选择 -->
                  <div class="select">
                    <RadioGroup
                      v-model="ite.answe"
                      vertical
                    >
                      <Radio
                        :label="it.option_k"
                        v-for="(it, ind) in ite.question.ques_options"
                        :key="ind"
                        :id="it.option_k"
                      >
                        <span v-html="it.option"></span>
                      </Radio>
                    </RadioGroup>
                  </div>
                </div>

                <!-- ***************题型2 填空题 ******************-->
                <Col v-if="is_2(ite)">
                  <h5>
                    <span class="index">{{ ite.start }}</span>

                    <div
                      class="text"
                      v-if="ite.question.formatData"
                      v-html="set_input_2(ite)"
                    ></div>
                  </h5>
                </Col>
                <!-- ***************题型3 听力选择题----单个问题 ******************-->

                <Col v-if="is_3(ite, 2)">
                  <!-- //大标题 -->
                  <h5>
                    <span class="index">{{ ite.start }}</span>
                    <div
                      class="text"
                      v-if="have_sub_heading(ite)"
                      v-html="set_sub_heading(ite)"
                    ></div>
                    <div
                      class="text"
                      v-else-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"
                    ></div>
                  </h5>
                  <!-- //大音频 -->
                  <!-- <div class="audio">  yang
                    <audio
                      controlsList="nodownload"
                      style="width: 180px; height: 30px"
                      v-if="ite.tigan_media"
                      :ref="'audio' + index"
                      controls
                      :src="path + ite.tigan_media"
                    ></audio>
                  </div> -->

                  <!-- 选择 -->
                  <div class="select">
                    <RadioGroup
                      v-model="ite.answe"
                      vertical
                      disabled
                    >
                      <Radio
                        :label="it.option_k"
                        v-for="(it, ind) in ite.question.ques_options"
                        :key="ind"
                        :id="it.option_k"
                      >
                        {{ it.option_k }}.
                        <span v-html="it.option"></span>
                      </Radio>
                    </RadioGroup>
                  </div>
                </Col>

                <!-- ***************题型3 听力----多个问题 ******************-->
                <Col v-if="is_3(ite, 1)">
                  <!-- //大标题 -->
                  <h5>
                    <span class="index" style="background: #fff"></span>
                    <div
                      class="text"
                      v-if="have_sub_heading(ite)"
                      v-html="set_sub_heading(ite)"
                    ></div>
                    <div
                      class="text"
                      v-else-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"
                    ></div>
                  </h5>
                  <!-- //大音频 -->
                  <!-- <div class="audio"> yang
                    <audio
                      controlsList="nodownload"
                      style="width: 180px; height: 30px"
                      v-if="ite.tigan_media"
                      :ref="'audio' + index"
                      controls
                      :src="path + ite.tigan_media"
                    ></audio>
                  </div> -->
                  <!-- 单个问题 -->
                  <div v-if="ite.question.formatData">
                    <div
                      v-for="(li, i) in ite.question.formatData.sub_headings"
                      :key="i"
                    >
                      <h5>
                        <span class="index">{{ ite.start + i }}</span>
                        <div
                          class="text"
                          v-if="li.sub_heading"
                          v-html="li.sub_heading"
                        ></div>
                        <div
                          class="text"
                          v-if="li.sub_src_txt"
                          v-html="li.sub_src_txt"
                        ></div>
                      </h5>
                      <div class="audio">
                        <audio
                          controlsList="nodownload"
                          style="width: 180px; height: 30px"
                          v-if="li.sub_src_audio"
                          :ref="'audio' + index"
                          controls
                          :src="li.sub_src_audio"
                        ></audio>
                      </div>
                      <div class="select">
                        <RadioGroup
                          vertical
                          v-model="li.answer.answer"
                        >
                          <Radio
                            :label="String(ind)"
                            v-for="(it, ind) in li.options"
                            :key="ind"
                            :id="it.option_k"
                          >
                            <span v-html="it.option"></span>
                          </Radio>
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                </Col>

                <!-- ***************题型4 听力填空题 ******************-->

                <Col v-if="is_4(ite)">
                  <!-- //大标题 -->
                  <h5>
                    <span class="index">{{ ite.start }}</span>

                    <div
                      class="text"
                      v-if="ite.question.formatData"
                      v-html="set_input_4(ite)"
                    ></div>
                    （
                    <div
                      class="text"
                      v-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"
                    ></div>
                    ）
                  </h5>
                  <!-- //大音频 -->
                  <!-- <div class="audio">  yang
                    <audio
                      controlsList="nodownload"
                      style="width: 180px; height: 30px"
                      v-if="ite.tigan_media"
                      :ref="'audio' + index"
                      controls
                      :src="path + ite.tigan_media"
                    ></audio>
                  </div> -->
                </Col>

                <!-- ***************题型5 阅读理解单个题 ******************-->
                <Col v-if="is_5(ite, 2)">
                  <h5>
                    <span class="index">{{ ite.start }}</span>
                    <div
                      class="text"
                      v-if="have_sub_heading(ite)"
                      v-html="set_sub_heading(ite)"
                    ></div>
                    <div
                      class="text"
                      v-else-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"
                    ></div>
                  </h5>
                  <!-- 选择 -->
                  <div class="select">
                    <RadioGroup
                      v-model="ite.answe"
                      vertical
                    >
                      <Radio
                        :label="it.option_k"
                        v-for="(it, ind) in ite.question.ques_options"
                        :key="ind"
                        :id="it.option_k"
                      >
                        {{ it.option_k }}.
                        <span v-html="it.option"></span>
                      </Radio>
                    </RadioGroup>
                  </div>
                </Col>

                <!-- ***************题型5 阅读理解多个题  ******************-->
                <Col v-if="is_5(ite, 1)">
                  <!-- //大标题 -->
                  <h5>
                    <span class="index" style="background: #fff"></span>
                    <div
                      class="text"
                      v-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"
                    ></div>
                  </h5>

                  <!-- 单个问题 -->
                  <div v-if="ite.question.formatData">
                    <div
                      v-for="(li, i) in ite.question.formatData.sub_headings"
                      :key="i"
                    >
                      <h5>
                        <span class="index">{{ ite.start + i }}</span>
                        <div
                          class="text"
                          v-if="li.sub_heading"
                          v-html="li.sub_heading"
                        ></div>
                        <div
                          class="text"
                          v-if="li.sub_src_txt"
                          v-html="li.sub_src_txt"
                        ></div>
                      </h5>

                      <div class="select">
                        <RadioGroup
                          vertical
                          v-model="li.answer.answer"
                        >
                          <Radio
                            :label="String(ind)"
                            v-for="(it, ind) in li.options"
                            :key="ind"
                            :id="it.option_k"
                          >
                            <span v-html="it.option"></span>
                          </Radio>
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                </Col>

                <!-- ***************题型6 长篇阅读_填空题  ******************-->
                <Col v-if="is_6(ite)">
                  <!-- //大标题 -->
                  <h5>
                    <span class="index" style="background: #fff"></span>
                    <div
                      class="text"
                      v-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"
                    ></div>
                  </h5>

                  <!-- 单个问题 -->
                  <div v-if="ite.question.formatData">
                    <div
                      v-for="(li, i) in ite.question.formatData.sub_headings"
                      :key="i"
                    >
                      <h5>
                        <span class="index">{{ ite.start + i }}</span>
                        <div
                          class="text"
                          v-if="li.sub_heading"
                          v-html="set_input_9(li.sub_heading, li.answer)"
                        ></div>
                      </h5>
                    </div>
                  </div>
                </Col>

                <!-- ***************题型7 n选n选择题  ******************-->
                <Col v-if="is_7(ite)">
                  <h5>
                    <span class="index">{{ ite.start }}</span>
                    <!-- //大问题文章带input -->
                    <div
                      class="text"
                      v-if="ite.question && ite.question.formatData.stem != ''"
                      v-html="set_input(ite.question.formatData)"
                    ></div>
                    <div
                      class="text"
                      v-else-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"
                    ></div>
                  </h5>
                  <!-- 选择 -->
                  <div class="select_no">
                    <RadioGroup
                      v-model="ite.answe"
                      vertical
                    >
                      <Radio
                        v-for="(it, ind) in ite.question.ques_options"
                        :key="ind"
                        :id="it.option_k"
                      >
                        <span>{{ it.option_k }} . </span>
                        <span v-html="it.option"></span>
                      </Radio>
                    </RadioGroup>
                  </div>
                </Col>

                <!-- ***************题型8 选择题文本资源 题型9 填空题带文本资源 ******************-->
                <Col v-if="is_8_9(ite)">
                  <!-- //大标题 -->
                  <h5>
                    <span class="index" style="background: #fff"></span>
                    <div
                      class="text"
                      v-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"
                    ></div>
                  </h5>

                  <!-- 单个问题  -->
                  <div v-if="ite.question.formatData">
                    <div
                      v-for="(li, i) in ite.question.formatData.sub_headings"
                      :key="i"
                    >
                      <!--  这里 是  88888888888888 类型   -->
                      <div v-if="li.options && li.options.length > 0">
                        <h5>
                          <span class="index">{{ ite.start + i }}</span>
                          <div
                            class="text"
                            v-if="li.sub_heading"
                            v-html="li.sub_heading"
                          ></div>
                          <div
                            class="text"
                            v-if="li.sub_src_txt"
                            v-html="li.sub_src_txt"
                          ></div>
                        </h5>

                        <div class="select">
                          <RadioGroup
                            vertical
                            v-model="li.answer[0].answer"
                          >
                            <Radio
                              :label="it.option_k"
                              v-for="(it, ind) in li.options"
                              :key="ind"
                              :id="it.option_k"
                            >
                              {{ String.fromCharCode(65 + it.option_k * 1) }}.
                              <span v-html="it.option"></span>
                            </Radio>
                          </RadioGroup>
                        </div>
                      </div>

                      <!-- 填空题  这里是 99999999999999999999 类型 -->

                      <div v-else>
                        <h5>
                          <span class="index">{{ ite.start + i }}</span>

                          <div
                            class="text"
                            v-if="li.sub_heading"
                            v-html="set_input_9(li.sub_heading, li.answer)"
                          ></div>
                        </h5>
                      </div>

                      <!-- 结束 -->
                    </div>
                  </div>
                </Col>

                <!-- ***************题型10 完形填空_填空题  ******************-->
                <Col v-if="is_10(ite)">
                  <!-- //大标题 -->
                  <h5>
                    <span class="index" style="background: #fff"></span>
                    <div
                      class="text"
                      v-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"
                    ></div>
                  </h5>

                  <!-- 单个问题 -->
                  <div v-if="ite.question.formatData">
                    <div
                      v-for="(li, i) in ite.question.formatData.sub_headings"
                      :key="i"
                    >
                      <h5>
                        <span class="index" v-if="ite.question_num">{{
                          ite.question_num
                        }}</span>
                      </h5>

                      <div class="select">
                        <RadioGroup
                          vertical
                          v-model="li.answer.answer"
                        >
                          <Radio
                            :label="String(ind)"
                            v-for="(it, ind) in li.options"
                            :key="ind"
                            :id="it.option_k"
                          >
                            <span v-html="it.option"></span>
                          </Radio>
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                </Col>

                <!-- 写作题 -->
                <Col v-if="is_11(ite)">
                  <div style="height: 12px"></div>

                  <div>
                    <p v-html="ite.question.ques_stem[0].stem"></p>
                  </div>
                  <div style="height: 12px"></div>
                  <p>
                    字数建议：下限：
                    <span v-html="ite.question.ques_stem[0].limit_l"></span
                    >上限：<span
                      v-html="ite.question.ques_stem[0].limit_r"
                    ></span>
                  </p>

                  <div style="height: 12px"></div>
                  <Input
                    disabled
                    v-model="ite.answe"
                    maxlength="100"
                    show-word-limit
                    type="textarea"
                    placeholder="Enter something..."
                  />
                  <div style="height: 12px"></div>
                </Col>
              </div>
            </div>


              <!-- <div>
                <h4>{{ ite.start}}、{{ ite.name }}(本题{{ ite.total_score?ite.total_score[0] * 1:'未知' }}分)</h4>
                <p class="mar10">答：{{ ite.answer }}</p>
                <br />
                <RadioGroup v-model="allRadio[i]" @change="rideoChange">
                    <Radio
                      label="1"
                    >0分</Radio>
                    <Radio
                      label="2"
                    >1分</Radio>
                  <Radio
                      label="3"
                    >2分</Radio>
                  </RadioGroup>
                <br />
              </div> -->
            </div>
          </Row>
          <Row style="width:100%;margin-top:10px" v-if="num[0] === indexs&&num[1] === index">
              <Col :span="20"></Col>
              <Col :span="4"
                ><Button @click="prex(indexs,index)" :disabled="preDisabled"
                  >上一题</Button
                ><Button @click="next(indexs,index)" :disabled="nextDisabled"
                  >下一题</Button
                ></Col
              >
            </Row>
          </div>
        </div>
      </Row>
      <Modal
      v-model="lookShow"
      @on-cancel="lookcancel()"
      title=""
    >
    <Row class="shuomingpop">
      <p class="shuomingp">请核对个人信息</p>
      <Col span="24" class="xinfos">
        <p>用户名：{{looksInfo.student?looksInfo.student.name:null}}</p>
        <p>姓名：{{looksInfo.student?looksInfo.student.real_name:null}}</p>
        <p>所属校区：{{looksInfo.student?looksInfo.student.campus_name:null}}</p>
      </Col>
      <Col span="24" class="shuoming">
        <p>考试说明</p>
        <div v-html="looksInfo.student?looksInfo.examination.remark:null"></div>
      </Col>
    </Row>
      <div slot="footer">
        <Button type="text" size="small" @click="lookcancel"
          >取消</Button
        >
        <Button type="primary" size="small" @click="sureInfo"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import audioplay from "./audioplay.vue";
export default {
   components: {
    audioplay,
  },
  data () {
    return {
      preDisabled: true, //上禁用按钮
      nextDisabled: false, //下禁用按钮
      num: [0,0], //第几题
      allRadio: [], //每题的选项
      answerList: [], //所有题的答案或分数
      examsList:[],
      lookShow:true,
      looksInfo:{},
      leftTime:0,
      hours: '00',
      minutes: '00',
      seconds: '00',
      oneName:'',
      twoName:'',
    }
  },
  computed: {
  },
  watch: {
    //第一题和最后一题禁用按钮
    num(now) {
      var i=this.examsList.length-1
      var a=this.examsList[i].child.length
      if (now[0] == i&&now[1] == (a-1)) {
        this.nextDisabled = true;
      } else {
        this.nextDisabled = false;
      }
      if (now[0] ==0&&now[1] < 1) {
        this.preDisabled = true;
      }else{
        this.preDisabled = false;
      }
    }
  },
  activated () {
      this.looksInfo={}
      this.getstudent()
   },
  methods: {
    have_sub_heading(ite) {
      return (
        ite.question.ques_sub_headings &&
        ite.question.ques_sub_headings.length > 0 &&
        ite.question.ques_sub_headings[0].sub_heading != ""
      );
    },
    set_sub_heading(ite) {
      return ite.question.ques_sub_headings[0].sub_heading;
    },

    // 完型填空类往inpu 中添加文字
    set_input(item) {
      let stem = item.stem;
      let answer = item.answer;
      let arr = stem.split("<Input/>");
      let newArr = "";
      arr.map(function (item, index) {
        if (index < arr.length - 1) {
          newArr += item + "<pre>" + answer[index].answer + "</pre>";
        } else {
          newArr += item;
        }
      });
      return newArr;
    },

    //题型2的 填空题往inpu 中添加文字
    set_input_2(ite) {
      let stem = ite.question.formatData.stem;
      let answer = ite.question.formatData.answer;
      let arr = stem.split("<Input/>");
      let newArr = "";
      arr.map(function (item, index) {
        if (index < arr.length - 1) {
          newArr += item + "<pre>" + answer[index].answer + "</pre>";
        } else {
          newArr += item;
        }
      });
      return newArr;
    },
    //题型4的 填空题往inpu 中添加文字
    set_input_4(ite) {
      let stem = ite.question.ques_sub_headings[0].sub_heading;
      let answer = ite.question.ques_answers;
      let arr = stem.split("<Input/>");
      let newArr = "";
      arr.map(function (item, index) {
        if (index < arr.length - 1) {
          newArr += item + "<pre>" + answer[index].answer + "</pre>";
        } else {
          newArr += item;
        }
      });
      return newArr;
    },

    // 9类型填空类往inpu 中添加文字
    set_input_9(item, answer_arr) {
      let stem = item;
      let answer = answer_arr;
      let arr = stem.split("<Input/>");
      let newArr = "";
      arr.map(function (item, index) {
        if (index < arr.length - 1) {
          newArr += item + "<pre>" + answer[index].answer + "</pre>";
        } else {
          newArr += item;
        }
      });
      return newArr;
    },
    //判断类型
    //基础选择题
    is_1(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == 1;
      }
    },
    //基础填空题
    is_2(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == "2";
      }
    },
    //听力选择题
    is_3(item, num) {
      if (item.question && item.question.formatData) {
        return (
          item.question.question_type.basic_ques_types == 3 &&
          item.question.question_type.batch == num
        );
      }
    },
    //听力填空题
    is_4(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == 4;
      }
    },

    //阅读理解选择题 单个
    is_5(item, num) {
      if (item.question && item.question.formatData) {
        return (
          item.question.question_type.basic_ques_types == 5 &&
          item.question.question_type.batch == num
        );
      }
    },
    //阅读理解填空题 多个
    is_5(item, num) {
      if (item.question && item.question.formatData) {
        return (
          item.question.question_type.basic_ques_types == 5 &&
          item.question.question_type.batch == num
        );
      }
    },
    //长篇阅读
    is_6(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == 6;
      }
    },
    //  <!-- n选n选择题 -->
    is_7(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == 7;
      }
    },

    is_8_9(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == "8,9";
      }
    },
    // <!-- 完形填空 -->
    is_10(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == 10;
      }
    },
    //是否是写作题
    is_11(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == 11;
      }
    },
    countTime () {
      const leftTime = this.leftTime
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // 时
        const h = Math.floor(leftTime / 1000 / 60 / 60 % 24)
        this.hours = h < 10 ? '0' + h : h
        // 分
        const m = Math.floor(leftTime / 1000 / 60 % 60)
        this.minutes = m < 10 ? '0' + m : m
        // 秒
        const s = Math.floor(leftTime / 1000 % 60)
        this.seconds = s < 10 ? '0' + s : s
      } else {
        this.hours = '00'
        this.minutes = '00'
        this.seconds = '00'
      }
      // 等于0的时候不调用
      if (Number(this.hours) === 0&& Number(this.minutes) === 0 && Number(this.seconds) === 0) {
        return
      } else {
      // 递归每秒调用countTime方法，显示动态时间效果,
        this.leftTime=this.leftTime-1000
        setTimeout(this.countTime, 1000)
      }
    },
      getstudent(){
          var that = this;
        that.$axios
        .get("/app/exam_enroll_student/index?id="+that.$route.query.id)
        .then((res) => {
            if (res.code == 1) {
            that.looksInfo = res.data;
            if(res.data.examination&&res.data.examination.time_limit){
              that.leftTime= res.data.examination.time_limit*60*1000
              that.countTime()
            }
            if(res.data.examination&&res.data.examination.status<3){
                this.lookShow=true
            }else{
                this.getshijuan(res.data.examination.id)
                this.lookShow=false
            }
            } else {
            that.$Message.error(res.msg);
            }
        });
      },
      getshijuan(id){
           var that = this;
        that.$axios
        .get("/app/exam_enroll_student/getInfo?examination_id="+id)
        .then((res) => {
            if (res.code == 1) {
            that.examsList = res.data.catalog;
            that.oneName=that.examsList[0]?that.examsList[0].name:null
            that.twoName=that.examsList[0]&&that.examsList[0].child[0]?that.examsList[0].child[0].name:null
            } else {
            that.$Message.error(res.msg);
            }
        });
      },
      rideoChange(val) {
      console.log(val);
      this.answerList.push(val);
    },
    gotoCar(w,p){
      this.num[0] = w;
      this.num[1] = p;
      console.log(this.num)
      this.num.forEach((item, index) => {
        this.$set(this.num, index,item)
      })
      this.oneName=this.examsList[this.num[0]]?this.examsList[this.num[0]].name:null
      this.twoName=this.examsList[this.num[0]]&&this.examsList[this.num[0]].child[this.num[1]]?this.examsList[this.num[0]].child[this.num[1]].name:null
      this.$forceUpdate();
    },
    next(w,p) {
      var that=this
      that.preDisabled = false;
      var i=that.examsList.length-1
      var a=that.examsList[i].child.length-1
      that.num[0]=w
      that.num[1]=p
      if (that.num[0] <= i&&that.num[1] < a) {
        if(that.num[1] == a){
          that.num[0]+=1;
          that.num[1]=1;
        }else{
          that.num[1]+=1;
        }
        that.num.forEach((item, index) => {
          that.$set(that.num, index,item)
        })
        that.oneName=that.examsList[that.num[0]]?that.examsList[that.num[0]].name:null
        that.twoName=that.examsList[that.num[0]]&&that.examsList[that.num[0]].child[that.num[1]]?that.examsList[that.num[0]].child[that.num[1]].name:null
        that.$forceUpdate();
      }
    },
    prex(w,p) {
      var that=this
      if (that.num[0] === 0&&that.num[1] === 0) {
        that.num = [0,0];
        that.oneName=that.examsList[0]?that.examsList[0].name:null
        that.twoName=that.examsList[0]&&that.examsList[0].child[0]?that.examsList[0].child[0].name:null
      } else {
        that.num[0]=w
        that.num[1]=p
        if(that.num[1] == 0){
          that.num[0]-=1;
        }else{
          that.num[1]-=1;
        }
        that.$set(that.num)
        that.num.forEach((item, index) => {
            that.$set(that.num, index,item)
        })
        that.oneName=that.examsList[that.num[0]]?that.examsList[that.num[0]].name:null
        that.twoName=that.examsList[that.num[0]]&&that.examsList[that.num[0]].child[that.num[1]]?that.examsList[that.num[0]].child[that.num[1]].name:null
        that.$forceUpdate();
      }
    },
    goSubmit() {
      this.submitDialog = true;
    },
    lookcancel(){
        this.lookShow=false
        this.$router.go(-1)
    },
    sureInfo(row){//确认信息
      var that=this
      that.$axios
        .get("/app/exam_enroll_student/beginAnswer?examination_id="+row.examination.id)
        .then((res) => {
            if (res.code == 1) {
            that.lookShow=false
            that.getshijuan(row.examination.id)
            } else {
            that.$Message.error(res.msg);
            }
        });
    }
  }
}
</script>
<style scoped lang='less'>
.exams{
    width:80%;
    margin:10px auto;
    .exams-row{
        width: 100%;
        padding:10px 0 10px 30px;
        display: flex;
        justify-items: center;
        justify-content: space-between;
        align-items: center;
        .exams-rowcol{
          display: flex;
          justify-content: space-around;
          align-items: center;
          .exams-rowdiv{
            display: flex;
            align-items: center;
          }
          .exams-rowcol-drop{
            font-size: 16px;
            .exams-rowcol-drop-tit{
              font-size: 20px;
              margin:10px 0;
              color: #333;
            }
            .exams-rowcol-drop-div{
              font-size: 15px;
              margin:10px 20px;
              min-width: 300px;
              max-width: 800px;
              a{
                display: inline-block;
                border-radius:50%;
                margin:10px;
                width: 30px;
                height:30px;
                color: #aaa;
                line-height: 30px;
                text-align: center;
                align-items: center;
                border:1px solid #aaa;
              }
            }
          }
        }
        .exams-right{
          display: flex;
          justify-content: flex-end;
          p{
              color:#2D8cF0;
              font-size: 24px;
              font-weight: 600;
          }
        }
    }
    .exams-rowp{
      background:#549ce9;
      padding:0px 20px;
      height:32px;
      display: flex;
      align-items: center;
      border-radius: 20px;
      color: #fff;
      p{
        max-width: 47%;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
      }
      .icon{
        width: 4%;
        height:100%;
      }
    }
    .exams-p{
      width: 100%;
      background: #ddd;
      line-height: 2.4;
      font-size: 16px;
      text-align: center;
    }
    .exams-list{
      width: 100%;
    }
}

.shuomingpop{
  max-height:70vh;
  overflow:auto;
  padding:10px;
  .shuomingp{
      width: 100%;
      text-align: center;
  }
  .xinfos{
      padding:10px 30px;
      p{
        background: #eee;
        padding:10px 30px;
        margin-bottom: 4px;
      }

  }
  .shuoming{
      padding:20px;
      p{
        font-weight: 600;
        text-align: center;
        color:#000;
      }
  }
}


//考题样式从这到底


/deep/.text > * {
  display: inline-block;
}
/deep/pre {
  border-bottom: 1px solid #333;
  display: inline-block;
  margin: 0;
  padding: 0 30px;
  min-width: 100px;
  color: #549ce9;
}
//选项颜色
/deep/.ivu-radio-disabled .ivu-radio-inner:after {
  background: #549ce9;
}
/deep/.ivu-radio-checked .ivu-radio-inner {
  border-color: #549ce9;
}
/deep/img {
  max-width: 320px !important;
}
/deep/textarea {
  display: inline-block;
  width: 100% !important;
}
/deep/input {
  border: none;
  border-bottom: 1px solid #999 !important;
  outline: none;
  text-align: center;
  font-weight: bold;
  color: #549ce9;
}

//音频播放器样式修改
.audio {
  padding: 10px 30px 5px 0;
  margin-bottom: 10px;
}
audio::-webkit-media-controls {
  border: 0;
  width: 380px !important;
  height: 80px !important;
  display: flex;
  align-items: center;
}
/* 音频面板 */
audio::-webkit-media-controls-panel {
  background: #fff;
}
/* 音量按钮 */
audio::-webkit-media-controls-mute-button {
  background: #fff;
}
/* 播放按钮 */
audio::-webkit-media-controls-play-button {
}
audio::-webkit-media-controls-play-button-icon {
  background: #fff;
  width: 50px;
  height: 50px;
}
audio::-webkit-media-controls-timeline-container {
  background: rgb(129, 128, 128);
}

/* 当前播放时长 */
audio::-webkit-media-controls-current-time-display {
}
/* 总时长 */
audio::-webkit-media-controls-time-remaining-display {
}
/* 播放进度条 */
audio::-webkit-media-controls-timeline {
  // display: none;
  width: 100px;
  //进度
}
/* 音量滑条面板 */
audio::-webkit-media-controls-volume-slider-container {
}

audio::-webkit-media-controls-volume {
  background: rgb(6, 173, 145);
}
/* 音量滑条 */
audio::-webkit-media-controls-volume-slider {
  // background: rgb(6, 173, 145);
  display: none;
  // 音量进度
}

//大盒子
.box {
  padding: 30px;
  background: #fff;
}
//h5 是问题字段
h5 {
  display: flex;
  // align-items: center;
  padding-left: 10px;
  padding-top: 10px;
  margin-bottom: 10px;
  //小标题下标
  .index {
    flex-shrink: 0;
    box-sizing: border-box;
    width: 24px;
    height: 24px;
    line-height: 25px;
    text-align: center;
    display: inline-block;
    background: #549ce9;
    border-radius: 50%;
    margin-right: 16px;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }
  //小标题
  .text {
  }
}

//考题大盒子
.questions {
  padding:10px;
  background: #fafafa;
  width: 100%;
  height:74vh;
  overflow: auto;
  .questions_title {
    // margin-bottom: 20px;
    font-size: 18px;
    line-height: 25px;
    padding: 18px 20px;
    background: #fafafa;
    position: relative;
  }
  .question_content {
    align-items: center;
    font-size: 16px;
    line-height: 22px;
  }
}

.select label {
  width: 100%;
  padding: 10px 10px 10px 45px;
  line-height: 20px;
  border-radius: 4px;
  cursor: pointer;
  margin: 0;
  position: relative;
  min-height: 40px;
  height: auto;
  display: flex;
}

.select_no label {
  width: 100%;
  padding: 10px 10px 10px 45px;
  line-height: 20px;
  border-radius: 4px;
  cursor: pointer;
  margin: 0;
  position: relative;
  min-height: 40px;
  height: auto;
  display: flex;
  /deep/.ivu-radio-disabled {
    display: none;
  }
}
/deep/span img {
  vertical-align: top;
}
</style>
